module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', [_c('br'), _vm._v(" "), _c('el-form', {
    ref: "appInfo",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.appInfo,
      "rules": _vm.rules,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "满",
      "prop": "coupon_num_x"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0.01,
      "max": 10000,
      "placeholder": " 0.01-10000",
      "label": "满X元"
    },
    model: {
      value: (_vm.appInfo.coupon_num_x),
      callback: function($$v) {
        _vm.$set(_vm.appInfo, "coupon_num_x", $$v)
      },
      expression: "appInfo.coupon_num_x"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " "
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "减",
      "prop": "coupon_num_y"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0.01,
      "max": 10000,
      "placeholder": " 0.01-10000",
      "label": "减Y元"
    },
    model: {
      value: (_vm.appInfo.coupon_num_y),
      callback: function($$v) {
        _vm.$set(_vm.appInfo, "coupon_num_y", $$v)
      },
      expression: "appInfo.coupon_num_y"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " "
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "规则描述"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.appInfo.rule_desc),
      callback: function($$v) {
        _vm.$set(_vm.appInfo, "rule_desc", $$v)
      },
      expression: "appInfo.rule_desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " "
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "使用说明"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.appInfo.rule_use_desc),
      callback: function($$v) {
        _vm.$set(_vm.appInfo, "rule_use_desc", $$v)
      },
      expression: "appInfo.rule_use_desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    },
    on: {
      "change": _vm.getGoodsStr
    },
    model: {
      value: (_vm.appInfo.goods_type),
      callback: function($$v) {
        _vm.$set(_vm.appInfo, "goods_type", $$v)
      },
      expression: "appInfo.goods_type"
    }
  }, [_vm._v("所有商品参加")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    on: {
      "change": _vm.getGoodsStr
    },
    model: {
      value: (_vm.appInfo.goods_type),
      callback: function($$v) {
        _vm.$set(_vm.appInfo, "goods_type", $$v)
      },
      expression: "appInfo.goods_type"
    }
  }, [_vm._v("部分商品参加")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [(_vm.appInfo.goods_type == 1) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showProduct()
      }
    }
  }, [_vm._v("获取商品")]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [(_vm.is_show_portion_product_list) ? _c('el-button', {
    attrs: {
      "disabled": _vm.batchdisable,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.batchRemoveGoods()
      }
    }
  }, [_vm._v("删除已选商品")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.is_show_portion_product_list) ? _c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.readGoodslist,
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.batchGetGoods
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "Image",
      "label": "商品图片"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "avatar",
          staticStyle: {
            "height": "50px"
          },
          attrs: {
            "src": scope.row.Image
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "商品价格"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "machine_id",
      "label": "机器编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "线上价格"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.price != '' && scope.row.SKU != '') ? _c('span', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v("上架")]) : _vm._e(), _vm._v(" "), (scope.row.price == '' && scope.row.SKU != '') ? _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("下架")]) : _vm._e(), _vm._v(" "), (scope.row.price == '' && scope.row.SKU == '') ? _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("已删除")]) : _vm._e()]
      }
    }])
  })], 1) : _vm._e(), _vm._v(" "), (_vm.is_show_portion_product_list) ? _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentpage,
      "page-count": _vm.pagesCount,
      "page-sizes": _vm.pagesizes,
      "page-size": _vm.pagesize,
      "total": _vm.pagesCount,
      "layout": " total, prev, pager, next, jumper"
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-chahange": _vm.handleSizeChange
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "商品",
      "visible": _vm.dialogVisible,
      "modal-append-to-body": false,
      "width": "70%",
      "top": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [(_vm.isShowProduct) ? _c('ProductPutWay', {
    attrs: {
      "kioskNoList": _vm.kioskNoList,
      "is_checkbox": _vm.is_checkbox
    },
    on: {
      "handle-selection-change": _vm.handleSelectionChange,
      "close-product": _vm.closeProduct
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "16.5%"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "id": "last_step"
    },
    on: {
      "click": function($event) {
        _vm.lastStep()
      }
    }
  }, [_vm._v("上一步\n            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "id": "next_step"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('appInfo')
      }
    }
  }, [_vm._v("保存修改\n            ")]), _vm._v(" "), (_vm.act_status == -1) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.startOrPaseAct('1')
      }
    }
  }, [_vm._v("提交")]) : _vm._e()], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "88%",
      "height": "40px",
      "line-height": "40px"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#adadad",
      "width": "150px",
      "height": "40px",
      "text-align": "center",
      "vertical-align": "middle",
      "float": "left"
    }
  }, [_vm._v("\n          满减活动配置\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#adadad",
      "margin-left": "2px",
      "width": "35%",
      "height": "40px",
      "text-align": "center",
      "color": "#adadad",
      "float": "left"
    }
  }, [_vm._v("\n            满减活动配置\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65d50aa9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/activity/FullSubtractApp.vue
// module id = 1072
// module chunks = 2